module.exports = __webpack_public_path__ + "static/media/idp.c75f709c.png";